import React from "react"
import DataTypeHelper from "./DataTypeHelper"

class NotificationIconDataType extends React.Component{
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="col-inline">{this.renderIcon(this.props.row.notification_type)} <strong>{DataTypeHelper.renderColumn("String", this.props.row.title, this.props)}</strong></div>
    );
  }

  renderIcon(notification_type) {
    if (notification_type == 'error') {
      return (
        <span className="ss-alert" style={{color: 'red', marginRight: 3}} />
      );
    } else {
      return (
        <span className="ss-info" style={{color: 'gray', marginRight: 3}} />
      );
    }
  }

};

export default NotificationIconDataType